import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["useSelector", "useDispatch", "query"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { Help } from '../../components/Help';
import { useReferenceUrl } from './useReferenceUrl';
import { jsx as _jsx } from "react/jsx-runtime";
export var HelpContainer = function HelpContainer(_ref) {
  var useSelector = _ref.useSelector,
    useDispatch = _ref.useDispatch,
    query = _ref.query,
    helpComponentProps = _objectWithoutProperties(_ref, _excluded);
  var refUrl = useReferenceUrl({
    useSelector: useSelector,
    useDispatch: useDispatch
  });
  var queryString = React.useMemo(function () {
    var queryParams = new URLSearchParams(query);
    if (refUrl) {
      queryParams.append('ref', refUrl);
    }
    return queryParams.toString();
  }, [query, refUrl]);
  return /*#__PURE__*/_jsx(Help, _objectSpread(_objectSpread({}, helpComponentProps), {}, {
    query: queryString
  }));
};